<template>
    <h3 class="m-heading-plain" :class="{ 'is-text-center': this.isCenter }">{{ this.text }}</h3>
</template>

<script>
    export default {
        name: "heading-plain",
        props: {
            /**
             * 見出しにするテキスト
             */
            text: {
               type: String,
               required: true
            },
            /**
             * テキストを中央寄せにするか
             */
            isCenter: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px
    .m-heading-plain {
        padding: $grid-consistent;
    }
</style>